export default class TimeAndExpense {
    id: number;
    name: string;
    number: number;
    acctNo: number;
    days: number;
    periodDays: number;
    billRate: number;
    payRate: number;
    billedServices: number;
    miles: number;
    mileage: number;
    meals: number;
    hotel: number;
    copies: number;
    phone: number;
    abstract: number;
    postage: number;
    shipping: number;
    other: number;
    expenses: number;
}



// WEBPACK FOOTER //
// ./src/models/AP/TimeAndExpense.ts